<template>
  <div class="mt-4 ml-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>文章内容</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin/mainContent/gameList' }"
          >游戏列表
        </el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">
            {{ this.gameId === 0 ? "添加游戏" : "编辑游戏" }}
          </span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <span class="font-weight-bold text-primary">
          {{ this.gameId === 0 ? "添加游戏" : "编辑游戏" }}
        </span>
      </div>
      <div style="height: 470px;overflow-y: auto;padding-right: 60px">
        <el-form :model="gameInfo" class="font-weight-bold" label-width="120px">
          <el-form-item label="游戏名称">
            <el-input
              v-model="gameInfo.gameName"
              placeholder="请输入游戏名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="游戏封面">
            <el-input
              v-model="gameInfo.gameImg"
              autocomplete="off"
              placeholder="游戏封面URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg"
                ref="gameImgUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸640*360像素</small>
            </div>
            <div class="mt-2">
              <el-image
                class="img-thumbnail text-muted"
                :src="gameInfo.gameImg"
                :preview-src-list="[gameInfo.gameImg]"
              />
            </div>
          </el-form-item>
          <el-form-item label="小屏封面">
            <el-input
              v-model="gameInfo.gameIcon"
              autocomplete="off"
              placeholder="游戏封面URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadIcon"
                ref="gameImgUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸72*72像素</small>
            </div>
            <div class="mt-2">
              <el-image
                class="img-thumbnail text-muted"
                :src="gameInfo.gameIcon"
                :preview-src-list="[gameInfo.gameIcon]"
              />
            </div>
          </el-form-item>
          <el-form-item label="是否上架">
            <el-radio-group v-model="gameInfo.status">
              <el-radio :label="true" border>是</el-radio>
              <el-radio :label="false" border>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="首页展示">
            <el-radio-group v-model="gameInfo.homeShow">
              <el-radio :label="true" border>是</el-radio>
              <el-radio :label="false" border>否</el-radio>
            </el-radio-group>
            <!--<small class="text-muted ml-3">选则是否上架</small>-->
          </el-form-item>
          <el-form-item label="游戏标签">
            <el-radio-group v-model="gameInfo.gameTag">
              <el-radio :label="0" border>无</el-radio>
              <el-radio :label="1" border>hot</el-radio>
              <el-radio :label="2" border>推荐</el-radio>
              <el-radio :label="3" border>新上</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="安卓下载链接">
            <el-input
              v-model="gameInfo.androidUrl"
              placeholder="请输入安卓下载地址或选择上传"
            ></el-input>
            <apk-upload
              @onUploadApk="uploadApk"
              ref="androidUrlUpload"
            ></apk-upload>
          </el-form-item>
          <el-form-item label="ios下载链接">
            <el-input
              v-model="gameInfo.iosUrl"
              placeholder="请输入IOS下载链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="Android下载量">
            <el-input
              v-model="gameInfo.gameDownloads"
              placeholder="Android下载量"
            ></el-input>
          </el-form-item>
          <el-form-item label="IOS点击量">
            <!--suppress JSUnresolvedVariable -->
            <el-input
              v-model="gameInfo.gameClicks"
              placeholder="IOS点击量"
            ></el-input>
          </el-form-item>
          <el-form-item label="游戏简介">
            <el-input
              type="textarea"
              v-model="gameInfo.gameProfile"
              placeholder="游戏简介"
              :autosize="{ minRows: 6, maxRows: 18 }"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitGameForm(gameInfo)"
              >立即提交
            </el-button>
            <el-button @click="cancelSubmit()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
import ImgUpload from "../../components/common/ImgUpload";
import ApkUpload from "../../components/common/ApkUpload";
export default {
  name: "GameForm",
  data() {
    return {
      gameId: this.$route.params.gameId,
      gameInfo: {
        gameImg: "",
        gameIcon: "",
        androidUrl: ""
      }
    };
  },
  components: {
    ImgUpload,
    ApkUpload
  },
  mounted() {
    if (this.gameId !== 0) {
      this.getGameById();
    }
  },
  methods: {
    getGameById() {
      this.axios
        .get("/game/getGameById", {
          params: {
            gameId: this.gameId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.gameInfo = resp.data.data;
          }
        });
    },
    uploadImg() {
      this.gameInfo.gameImg = this.$refs.gameImgUpload.url;
    },
    uploadIcon() {
      this.gameInfo.gameIcon = this.$refs.gameImgUpload.url;
    },
    uploadApk() {
      this.gameInfo.androidUrl = this.$refs.androidUrlUpload.url;
    },
    submitGameForm(gameInfo) {
      this.axios
        .post("/game/admin/addOrUpdateGame", {
          gameId: gameInfo.gameId,
          gameName: gameInfo.gameName,
          gameImg: gameInfo.gameImg,
          gameIcon: gameInfo.gameIcon,
          status: gameInfo.status,
          gameTag: gameInfo.gameTag,
          gameDownloads: gameInfo.gameDownloads,
          homeShow: gameInfo.homeShow,
          androidUrl: gameInfo.androidUrl,
          iosUrl: gameInfo.iosUrl,
          gameProfile: gameInfo.gameProfile
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.$router.push({ name: "GameList" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    },
    cancelSubmit() {
      this.$router.push({ name: "GameList" }).catch();
    }
  }
};
</script>

<style scoped></style>
